import React from "react";
import SelectField from "./SelectField";
import { countries } from "../utils/countries";

const MobileNumberWithCountryCode = ({ selectedPhoneCountry, mobile, onChange, onMobileChange }) => {
  const items = countries.map((it) => ({ label: `${it.country_code} (${it.phone_code})`, value: it.country_code }));
  const handleOnChange = (e) => onChange(e.target.value);
  return (
    <div>
      <div className="d-flex flex-column gap-2 mb-2">
        <span className="text-black fs-normal">{"Mobile Number"}</span>
        <div className="d-flex flex gap-2 mb-2">
          <select style={{ width: 85 }} className="border-0 bg-grey2 py-2 px-2 rounded text-black fs-sm" defaultValue={selectedPhoneCountry} placeholder="Select a country code" onChange={handleOnChange}>
            {items?.map((it) => (
              <option key={it.value} value={it.value} selected={selectedPhoneCountry === it.value}>
                {it.label}
              </option>
            ))}
          </select>
          <input className="bg-grey2 w-75 border-0 outline-0 px-2 py-2 rounded fs-md text-black fw-medium" value={mobile} type={"text"} onChange={(e) => onMobileChange(e.target.value)} placeholder={"Enter mobile number"} />
        </div>
      </div>
    </div>
  );
};

export default MobileNumberWithCountryCode;
